import { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { format, startOfWeek, addWeeks, subWeeks } from "date-fns";
import { useRef } from "react";

import api from "../../Utils/api";

const WeeklySelector = ({ getMyScheduels, totalHours }) => {
  const [currentStartDate, setCurrentStartDate] = useState(
    startOfWeek(new Date(), { weekStartsOn: 1 })
  ); // Monday start

  useEffect(() => {
    getMyScheduels(currentStartDate);
  }, [currentStartDate]);

  const nextWeek = () => {
    setCurrentStartDate((prev) => addWeeks(prev, 1));
  };

  const prevWeek = () => {
    setCurrentStartDate((prev) => subWeeks(prev, 1));
  };

  const start = format(currentStartDate, "dd MMM");
  const end = format(addWeeks(currentStartDate, 1) - 1, "dd MMM"); // end of current week

  const inputRef = useRef(null);

  const handleDateChange = (e) => {
    const selected = new Date(e.target.value);
    setCurrentStartDate(startOfWeek(selected, { weekStartsOn: 1 }));
  };

  return (
    <div className="flex items-center justify-between p-4 bg-white rounded-xl border border-gray-200">
      {/* Left: Navigation + Date */}
      <div className="flex items-center space-x-2">
        {/* Prev Button */}
        <button
          className="p-2 rounded-md hover:bg-gray-100 transition bg-gray-100 hover:bg-gray-200"
          onClick={prevWeek}
          aria-label="Previous Week"
        >
          <FaChevronLeft className="text-gray-600" />
        </button>

        {/* Date Display triggers native date input */}
        <div
          onClick={() => inputRef.current?.click()}
          className="text-sm font-semibold text-gray-600 px-4 py-2 rounded-md cursor-pointer hover:bg-gray-50 transition bg-gray-100"
        >
          {start} – {end}
        </div>

        {/* Hidden native date input */}
        <input
          type="date"
          ref={inputRef}
          onChange={handleDateChange}
          className="hidden"
        />

        {/* Next Button */}
        <button
          className="p-2 rounded-md hover:bg-gray-200 transition bg-gray-100 hover:bg-gray-200"
          onClick={nextWeek}
          aria-label="Next Week"
        >
          <FaChevronRight className="text-gray-600" />
        </button>
        {/* Today Button */}
        <button
          onClick={() =>
            setCurrentStartDate(startOfWeek(new Date(), { weekStartsOn: 1 }))
          }
          className="ml-8 text-sm text-gray-600 bg-gray-100 font-medium transition p-2 rounded hover:bg-gray-200"
        >
          Today
        </button>
      </div>

      {/* Right: Weekly Total */}
      <div className="text-sm text-gray-600">
        <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-md font-medium">
          Weekly Total: {totalHours.toFixed(2)} hrs
        </span>
      </div>
    </div>
  );
};

export default WeeklySelector;
